import { call, put, select } from 'redux-saga/effects';
import updateActiveCount from '../updateActiveCount/updateActiveCount';
import updateIsConference from '../updateIsConference/updateIsConference';
import { selectCallSessions, setCallSessions, selectActiveCallId } from '../../../state/callSessions/callSessionsSlice';
import { syncYealinkWithCall } from '../../../utils/devices';

export default function* addCallSession({ payload: callSession }) {
  const sessions = yield select(selectCallSessions);
  const newSessions = [...sessions, callSession];
  yield put(setCallSessions(newSessions));
  yield call(updateActiveCount);
  yield call(updateIsConference);

  // Sync the active call state to Yealink headset when new session is added
  try {
    const activeCallId = yield select(selectActiveCallId);
    const activeCall = newSessions.find((session) => session.id === activeCallId);

    if (activeCall) {
      yield call(syncYealinkWithCall, activeCall);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('addCallSession - sync error:', error);
  }
}
